<template>
  <div>
    <span class="text-caption pl-6">{{ t('header.auto-complete.input.alternative-query.title') }}</span>
    <v-list-item
      v-for="(alternativeQuery, index) in alternativeQueries"
      :key="index"
      class="d-inline-block text-decoration-underline"
      ripple
      density="compact"
      @mousedown.prevent
      @click="$emit('onSelect', alternativeQuery.value)"
      @keydown.enter="$emit('onSelect', alternativeQuery.value)"
    >
      <div>
        <div class="font-weight-regular">
          {{ alternativeQuery.text }}
        </div>
      </div>
    </v-list-item>
    <v-divider />
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue'
import { IAutocompleteItemModel } from '@src/types/autocomplete.types'

import { useI18n } from '@src/composables/useI18n'

export default defineComponent({
  name: 'SMAlternativeQueries',
  props: {
    alternativeQueries: {
      type: Array as PropType<IAutocompleteItemModel[]>,
      default: () => []
    }
  },
  setup() {
    const { t } = useI18n()
    return { t }
  }
})

</script>
